import { action } from 'mobx'
import { size } from 'lodash'
import Logger from 'core/jsLogger'
import store from '../store'
import Conversation from '../models/Conversation'
import { ccpProvider } from 'core/CcpProvider'

export default class Widget {

  @action
  async fetchConversationsForUser(userUid) {
    const [result, error] = await ccpProvider.api.widget.fetchConversationsForUser( { userUid }, { useCache: false })
    if (error) {
      Logger.error('[userConversations]', error)
      if (error.code == 'wrongWhitelabel') {
        console.warn('404 wrongWhitelabel returned - shutting down websocket (no reattempts)')
        window.__PROVIDER.websocket.disconnect()
      }
      throw new Error(error)
    }

    const { cache } = result
    const response = result.response || result
    store.user.block = response.block
    store.user.secondBlock = response.secondBlock
    store.user.blockType = response.blockType
    store.user.blockMessage = response.blockMessage
    store.user.premium = response.premium
    store.user.hasusedfreesexicon = response.hasusedfreesexicon

    if (response && size(response.conversations)) {
      const { conversations } = response
      if (store.isDev) {
        console.warn(`[${cache ? 'cached ' : ''}userConversations]`, conversations)
      }
      store.conversations.replace(conversations.map(c => new Conversation(c, true)))
    } else {
      if (store.isDev) {
        console.warn('[userConversations] no conversations found.')
      }
    }
  }

  @action
  async fetchWidgetConfig() {
    return ccpProvider.api.user.getConfig()
  }

  @action
  setWidgetState(state = {}) {
    const newState = { ...store.widgetState, ...state }

    localStorage[`widgetStateFor:${window.CONFIG.userUid}`] = JSON.stringify({ ...newState, set: Date.now() })

    Object.assign(store.chat, newState)
  }

  @action
  leave() {
    store.conversations.forEach(conversation => {
      conversation.meActive = false
    })
    return ccpProvider.api.widget.leave()
  }

  @action
  back() {
    store.conversations.forEach(conversation => {
      conversation.meActive = true
    })
    return ccpProvider.api.widget.back()
  }
}
